import ModalActionSalesHistories from './ModalActionSalesHistories'
export default ModalActionSalesHistories
